module.exports = __webpack_public_path__ + "assets/img/bg-0cc68cfc.jpg";